export enum EThresholdUnits {
  GB = 'Gb',
  MB = 'Mb',
  KB = 'Kb'
}
